import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSitemap, faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";

const Amalgamated = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faSitemap} className="me-2" />
            Amalgamated Fund
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(142,68,173,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faHandHoldingHeart} className="me-2" />
              About Amalgamated Fund
            </h4>
          </div>
          <CardBody className="p-5">
            <p style={{ color: '#495057', lineHeight: '1.8', textAlign: 'justify', fontSize: '1.05rem' }}>
              The Haryana Amalgamated Fund was established on August 23, 1985.
              The Funds objective include providing stipends for technical /vocational
              training, rehabilitation loans, scholarship for dependents, grants for medical
              treatment and maintaining Sainik Rest Houses.
            </p>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Amalgamated